module.exports = __webpack_public_path__ + "static/img/rainmaker-logo.17bfed8.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/svg/rainmaker-logo.svg
// module id = /YHP
// module chunks = 0